import React from "react";
import { api } from "../../config";
import MainButton from "../components/common/mainButton";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { Modal } from "antd";

import store from "../redux/store";
import * as Actions from "../redux/actions";

const GetCategorias = ({
  pathname,
  categorias,
  isMyCatalog,
  setCategorias,
  setLoader,
  setIsMyCatalog,
  catalogoId,
}) => {
  // const productos = useSelector((state) => state.catalog.catalogData.products);

  // const checkMarcas = (category) => {

  //   let ordenProductsByCategoria =
  //     productos &&
  //     productos.reduce((list, item) => {
  //       if (!list[item.categoria]) {
  //         list[item.categoria] = [];
  //       }

  //       list[item.categoria].push(item);

  //       return list;
  //     }, {});

  //  const filterProducts = ordenProductsByCategoria[category].reduce(
  //     (list, item) => {
  //       if (!list[item.marca.toLowerCase()]) {
  //         list[item.marca.toLowerCase()] = [];
  //       }

  //       list[item.marca.toLowerCase()].push(item);

  //       return list;
  //     },
  //     {}
  //   );

  //   return Object.keys(filterProducts).map((el) => el.replace(/\s/g, "-"));
  // };

  const { t } = useTranslation(["data"]);

  return categorias
    .sort((a, b) => a.categoryOrder - b.categoryOrder)
    .map((element, i) => {
      // const marcas = checkMarcas(element);

      return (
        <div key={i} className="block">
          <div className="block-title category">{element.name}</div>
          <div className="background">
            <img src={`${api.media.images}${element.code}`} />
          </div>
          <div className="button">
            <MainButton
              link={`${pathname}/${element.code}`}
              name={t("verProductos")}
            />
          </div>
          <div className="delete-categories-button">
            <div className="box">
              {isMyCatalog && (
                <a
                  onClick={(e) => {
                    e.preventDefault();

                    Modal.confirm({
                      title: "Confirmar",
                      content:
                        "Estas seguro/a que quieres eliminar categoria ?",
                      okText: "Eliminar",
                      cancelText: "Cancelar",
                      onOk: () => {
                        store
                          .dispatch(
                            Actions.deleteProducts({
                              catalogId: catalogoId,
                              categoryId: element.code,
                            })
                          )
                          .then(() => {
                            store
                              .dispatch(Actions.getCategories(catalogoId))
                              .then((data) => {
                                setCategorias(data.payload.data.categorias);
                                setIsMyCatalog(data.payload.data.isInMyCatalog);
                              });
                          });
                      },
                    });
                  }}
                >
                  <div className="icon-descargar">
                    <img src="/assets/img/delete-icon.png" />
                  </div>
                </a>
              )}
            </div>
          </div>
        </div>
      );
    });
};

export default GetCategorias;
